/**
 * Whether the docked sidebar (Questions, Lists, Data, Settings) is docked or folded, remembered on this device:
 * one choice for every section, read before the first paint so a folded sidebar never shows open and then folds.
 * The boot puts it on the root (`data-sidebar`); the shell reads it from there and writes every change back.
 */

const KEY = "adea.sidebar";

/** Boot: the remembered choice onto the root, before React renders. */
export function startSidebar(): void {
  try {
    const value = window.localStorage.getItem(KEY);
    if (value === "folded" || value === "docked") document.documentElement.dataset.sidebar = value;
  } catch {
    // Storage can be blocked; the sidebar then starts docked on wide windows.
  }
}

/** Docked (true), folded (false), or nothing remembered (null). */
export function rememberedSidebar(): boolean | null {
  const value = document.documentElement.dataset.sidebar;
  return value === "docked" ? true : value === "folded" ? false : null;
}

/** Remember a docked or folded sidebar on this device. */
export function rememberSidebar(docked: boolean): void {
  const value = docked ? "docked" : "folded";
  document.documentElement.dataset.sidebar = value;
  try {
    window.localStorage.setItem(KEY, value);
  } catch {
    // Not remembered on this browser; it holds for this visit.
  }
}
